import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TableFilterOption } from '@fly/shared';
import { DropdownMenu, RadioGroup, ScrollArea } from '@radix-ui/themes';
import cn from 'classnames';

export const FlyFilterDropdown = <T extends object>({
  trigger,
  possibleFilters,
  onChange,
  value,
}: {
  trigger: React.ReactNode;
  possibleFilters: TableFilterOption<T>[];
  onChange: (filter: TableFilterOption<T>) => void;
  value?: string;
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleFilterChange = (value: string) => {
    const filter = possibleFilters.find((f) => f.key === value);
    if (filter) {
      onChange(filter);
    }
    setOpen(false);
  };

  return (
    <DropdownMenu.Root open={open} onOpenChange={setOpen}>
      <DropdownMenu.Trigger>{trigger}</DropdownMenu.Trigger>
      <DropdownMenu.Content className='p-0'>
        <div className='flex min-w-[100px] flex-col'>
          <ScrollArea
            scrollbars='vertical'
            className={cn(
              'max-h-[300px]',
              possibleFilters.length < 2 && 'h-[82px]'
            )}
          >
            <RadioGroup.Root
              name='repo'
              onValueChange={handleFilterChange}
              value={value}
            >
              {possibleFilters.map((i) => (
                <RadioGroup.Item
                  key={i.key}
                  value={i.key}
                  data-testid={`table-filter-add-option-${i.key}`}
                  className='w-full border-(--fly-color-scheme-gray-3) pt-fly-3 pb-fly-3 text-custom-12 not-last:border-b-[0.5px]'
                >
                  {i.name != null ? t(...i.name) : i.key}
                </RadioGroup.Item>
              ))}
            </RadioGroup.Root>
          </ScrollArea>
        </div>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
